<h2 mat-dialog-title>
  <mat-icon>{{ isEdit ? 'edit' : 'add' }}</mat-icon>
  {{ isEdit ? 'Edit Knowledge Page' : 'Create Knowledge Page' }}
</h2>

<mat-dialog-content>
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Name (slug)</mat-label>
    <input
      matInput
      [(ngModel)]="name"
      placeholder="e.g. patreon_perks"
      maxlength="64"
      required>
    <mat-hint>Lowercase letters, numbers, underscores or hyphens. Passed verbatim to the bot's AI as an enum value.</mat-hint>
    @if (name.trim() && !isNameValid) {
      <mat-error>Only lowercase letters, numbers, "_" and "-" are allowed</mat-error>
    }
    @if (isNameTaken) {
      <mat-error>A page with this name already exists</mat-error>
    }
  </mat-form-field>

  @if (isRenamed) {
    <div class="rename-warning">
      <mat-icon>warning</mat-icon>
      <span>Renaming from <code>{{ originalName }}</code> to <code>{{ name.trim() }}</code>. Cult Bot's cache and anything referencing the old name will need updating.</span>
    </div>
  }

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Description</mat-label>
    <input
      matInput
      [(ngModel)]="description"
      placeholder="One line summary shown to the AI model, e.g. Troubleshooting Patreon Perks"
      maxlength="255"
      required>
    <mat-hint align="end">{{ description.length }}/255 &middot; shown to the AI so it knows when to read this page</mat-hint>
  </mat-form-field>

  <mat-tab-group class="content-tabs" animationDuration="0ms">
    <mat-tab label="Edit">
      <mat-form-field appearance="outline" class="full-width content-field">
        <mat-label>Content (Markdown)</mat-label>
        <textarea
          matInput
          [(ngModel)]="content"
          placeholder="Full page body returned to the bot when this page is read. Markdown is supported."
          rows="14">
        </textarea>
      </mat-form-field>
    </mat-tab>
    <mat-tab label="Preview">
      <div class="markdown-preview" [innerHTML]="renderedContent"></div>
    </mat-tab>
  </mat-tab-group>

  <mat-slide-toggle [(ngModel)]="published" class="published-toggle">
    Published (visible to Cult Bot's AI)
  </mat-slide-toggle>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">
    <mat-icon>cancel</mat-icon>
    Cancel
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="onSave()"
    [disabled]="!canSave">
    <mat-icon>save</mat-icon>
    {{ isEdit ? 'Save Changes' : 'Create Page' }}
  </button>
</mat-dialog-actions>
